import CommandObject from "./CommandObject";

export default class AddTextCommandObject extends CommandObject {
    constructor(undoHandler, id) {
        super(undoHandler, true);
        this.shapeId = id;
    }
    
    /* override to return true if this command can be executed,
    *  e.g., if there is an object selected
    */
    canExecute() {
        return this.undoHandler.getState().selectedObj !== null; // global variable for selected
    }

    /* override to execute the action of this command.
    * pass in false for addToUndoStack if this is a command which is NOT
    * put on the undo stack, like Copy, or a change of selection or Save
    */
    execute() {
        let state = this.undoHandler.getState()
        let selectedObj = state.shapesMap[this.shapeId];
        if (selectedObj) {
            this.oldValue = selectedObj.oldText;
            this.newValue = selectedObj.newText;
            selectedObj.oldText = this.newValue;

            // Note that this command object must be a NEW command object so it can be
            // registered to put it onto the stack
            if (this.addToUndoStack) this.undoHandler.registerExecution(this);
        }
    }

    /* override to undo the operation of this command.
    * this should be a NEW command object so it can be put on the undo stack.
    * execute will only be called if addToUndoStack was true, so it must
    * be an undoable operation. Be sure to register this
    * object on the undo stack.
    */
    undo() {
        let state = this.undoHandler.getState()
        let selectedObj = state.shapesMap[this.shapeId];
        if (selectedObj) {
            selectedObj.oldText = this.oldValue;
            selectedObj.newText = this.oldValue;
        }
        // this.undoHandler.updateText(this.shapeId, this.oldValue);
    }

    /* override to redo the operation of this command, which means to
    * undo the undo. This should ONLY be called if the immediate
    * previous operation was an Undo of this command. Anything that
    * can be undone can be redone, so there is no need for a canRedo.
    */
    redo() {
        let state = this.undoHandler.getState()
        let selectedObj = state.shapesMap[this.shapeId];
        if (selectedObj) {
            selectedObj.oldText = this.newValue;
            selectedObj.newText = this.newValue;
        }
        // this.undoHandler.updateText(this.shapeId, this.newValue);
    }

    /* override to return true if this operation can be repeated in the
    * current context. NOTE: Repeat is extra credit.
    */
    canRepeat() {
        return false;
    }

    /* override to execute the operation again, this time possibly on
    * a new object. Thus, this typically uses the same value but a new
    * targetObject. Be sure to register this
    * object on the undo stack.  NOTE: Repeat is extra credit.
    */
    repeat() {}
}